<template>
  <div class="News">
    <div class="banner">
      <PageBanner :bannerObj="bannerObj"></PageBanner>
      <div class="cont wow bounceInUp">
        <ComList
          :PageSize.sync="PageSize"
          :PageNo.sync="PageNo"
          :Total.sync="Total"
          infoColumn="2"
          baseDetailsUrl="industryNewsDetails"
          listType="imgList"
        ></ComList>
      </div>
    </div>
  </div>
</template>
<script>
import PageBanner from "../../components/common/pageBanner";
import ComList from "../../components/news/comList";
export default {
  name: "News",
  metaInfo() {
    return {
      title: "行业动态",
      meta: [
        {
          name: "keywords",
          content: "广州化工行业协会,专业技术人才,职业技能人才",
        },
        {
          name: "description",
          content:
            "广州市化工行业协会成立于1999年4月，是由广州地区从事化学工业和化工相关产业的生产、经营、储存、设计、服务咨询等企业或事业单位自愿结成的地方性、非营利性的社会组织。",
        },
      ],
    };
  },
  data() {
    return {
      Total: 1, // 总数
      PageNo: 1, // 当前页
      PageSize: 5, // 每页显示条数
      bannerObj: {
        lableZh: "行业动态",
        lableEn: "NEWS",
        bannerImg: require("../../assets/img/industryNews_banner.png"),
      },
    };
  },
  created() {
    // this.getInfoManageList();
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {
    // 获取banner
    async getBanners() {
      let res = await this.$request.getImageAdvertisingList({
        advertisingPosition: "3",
      });
      if (res.code === 200) {
        this.resBanners = [];
        res.rows.map((item) => {
          item.imageUrl = this.$store.state.baseUrl + item.imageUrl;
        });
        this.resBanners = res.rows;
      }
    },
  },
  components: { PageBanner, ComList },
};
</script>
<style lang="scss" scoped>
$themeColor: #003b99;
$themeMinWidth: 1180px;
.textslh {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.News {
  width: 100%;
  min-width: $themeMinWidth;
  box-sizing: border-box;
  .banner {
    width: 100%;
  }
}
</style>
